const numberWithDots = (num?: number | string, precision?: number) => {
  if (num === undefined || num === null) {
    return '';
  }
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  if (precision !== undefined && parts.length > 1) {
    if (precision === 0) {
      parts.pop();
    } else {
      parts[1] = parts[1].substr(0, precision);
    }
  }
  return parts.join('.');
};

const parseNumberToLocale = (num?: number | string, uom?: string) =>
  `${num?.toLocaleString(window.navigator.language, { maximumFractionDigits: 2 })}${uom ? ' ' + uom : ''}`;

const parseNumberToLocaleInMillions = (num: number, maxPrecision: number = 2, uom?: string) => {
  const numInMillions = num / 1000000;

  return `${numInMillions?.toLocaleString(window.navigator.language, { maximumFractionDigits: maxPrecision })}${
    uom ? ' ' + uom : ''
  }`;
};

const parsePercentToLocale = (num: number, precision: number = 0) => {
  return num.toLocaleString(window.navigator.language, { style: 'percent', minimumFractionDigits: precision });
};

export { numberWithDots, parseNumberToLocale, parsePercentToLocale, parseNumberToLocaleInMillions };
